//插件模块
import axios from 'axios'
import Cookies from 'js-cookie'
import { Message,MessageBox} from 'element-ui'
import router from '../../router'
import store from '../../store'
import baseURL from '../../config'

/* axios.defaults.baseURL = "http://127.0.0.1:8080";//本机
axios.defaults.baseURL = "http://192.168.2.119:8080";//本机 */
//axios.defaults.baseURL = "http://jxcr.coopwin.vip";//线上

axios.defaults.baseURL = "http://192.168.2.127:8080";//本机
//axios.defaults.baseURL = "http://127.0.0.1:8080";
axios.defaults.baseURL = window.location.host;
/* axios.defaults.baseURL = "http://jxc.coopwin.vip";//线上
 */

axios.defaults.baseURL = baseURL;
axios.defaults.timeout = 20000;
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'

const MyHttpServer = {

}

//接口统一处理
const SUCCESS = '200';//请求接口处理成功
const noLogin = "203";//未登录状态

//使用iframe框架下载文件
const downloadUrl = url => {
  //console.log(router,8888);
  let iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  iframe.onload = function () {
    document.body.removeChild(iframe)
  }
  document.body.appendChild(iframe);
}

//http request 拦截器
axios.interceptors.request.use(
  config => {
    /* 提交的数据 */
    /* console.log("===== 请求数据URL",config.url," ====");
    console.log("请求的数据",JSON.stringify(config.data)); */
    /* 下载 */
    if (config.headers && (config.headers['Content-Type'] === 'application/x-msdownload' || config.headers['Content-Type'] === 'application/vnd.ms-excel')) {
      let responseURL = config.baseURL + config.url;
      downloadUrl(responseURL);
      return {data:{rCode:'success'}}
    }
    /* 提交的数据 */
    if(!store.state.isLogin){}
    store.state.isLoading = true;//局部加载
    //store.state.isShow = true; //在请求发出之前进行一些操作
    return config
  },
  err => {
    //console.log('====== 请求错误 =======');
    store.state.isLoading = false;//局部加载
    //store.state.isShow = false;
    Message({
      message:"加载超时",
      type:"error",
      duration:1500
    });
    return Promise.reject(err);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  response => {
    //console.log('返回的数据',response.data);
    //store.state.isShow = false;
    store.state.isLoading = false;//局部加载
    if(response.status == noLogin){//未登录
      Cookies.remove('isLogin');
      router.replace({'path':'/login',query: {redirect: router.currentRoute.fullPath}});
    }else if(response.status === SUCCESS){//成功
      Cookies.set('isLogin',true);
    }else{//失败

    }
    //console.log(response.status,7777);
    return response.data;
  },
  error => {
    store.state.isLoading = false;//局部加载
    //超时之后在这里捕抓错误信息.
/*      if (error.response) {
          console.log('error.response')
          console.log(error.response);
      } else if (error.request) {
          console.log(error.request)
          console.log('error.request')
          if(error.request.readyState == 4 && error.request.status == 0){
              //我在这里重新请求
          }
      } else {
          console.log('Error', error.message);
      }
      console.log(error.config);
 */

    /* store.state.isLoading = false;//局部加载
    console.log("请求错误返回",error,error.response); */
    if(error && error.response){
      switch(error.response.status){
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "未授权，请重新登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误，未找到该资源";
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器拒绝访问";
          break;
        default:
          error.message = "未知错误";
          break;
      }
      error.message = error.response.data.message ? error.response.data.message : error.message;
      Message({
        message:error.message,
        type:"error",
        duration:1500
      });
    }else if(error && error.request){
      if(error.request.readyState == 4 && error.request.status == 0){
        //store.state.isShow = false;
        //服务器加载错误，请稍后再试
        /* Message({
          message:"服务器加载错误，请稍后再试",
          type:"error",
          duration:1500
        }); */
      }
    }else{
      //console.log('==其他错误===');
    }
    return Promise.reject(error);
  }
)


// 添加实例方法
const post = (url,params)=>{
  //console.log(url,baseUrl,666);
  return axios({
    url:url,
    method: 'post',
    data: params,
    withCredentials:true,
    headers:{
      'Content-Type':'application/json;charset=UTF-8'
    }
  }).then(res=>{
    const {type,msg} = res;
    if(type === "S"){//返回结果处理成功
      let msg = res.msg ? res.msg : "操作成功";
      res.msg = msg;
      res.status = true;
    }else{
      let msg = '';
      if(res.errorFields){
        res.errorFields.forEach((item)=>{
          if(item.errorDesc){
            msg += item.errorDesc+','
          }
        });
      }
      let errorMsg = msg ? msg : res.msg ? res.msg : "操作错误";
      res.errorMsg = errorMsg;
      res.status = false;
    }
    return res;
  })
  .catch(error=>{
    const res = {};
    res.status = false;
    return error;
  })
}

//GET
const get = (url,params) => {
  return axios({
    url:url,
    method: 'get',
    params: params,
    withCredentials:true,
    /* headers:{
      //'Content-Type':'application/json;charset=UTF-8'
      'Content-Type':'application/x-www-form-urlencoded'
    } */
  }).then(res=>{
    const {type,msg} = res;
    if(type === "S"){//返回结果处理成功
      res.status = true;
    }else{
      res.status = false;
    }
    return res;
  })
  .catch(error=>{
    Message({
      message:"服务器错误，请联系管理员",
      type:"error",
      duration:3000
    });
    return error;
  })
}

// 添加实例方法 - 上传文件
const upload = (url,params)=>{
  return axios({
    url:url,
    method: 'post',
    data: params,
    withCredentials:true,
    headers:{"Content-Type": "multipart/form-data"}
  }).then(res=>{
    const {type,msg} = res;
    if(type === "S"){//返回结果处理成功
      res.status = true;
    }else{
      res.status = false;
    }
    return res;
  }).catch(error=>{
    const res = {};
    res.status = false;
    return error;
  })
};


/*  导出 excel */
const exportExcel = (url,params) => {
  return axios({
    url:url,
    method: 'post',
    data: params,
    withCredentials:true,
 /*  headers: {
    'Content-Type': 'application/x-www-form-urlencoded', //请求的数据类型为form data格式
  },
  'responseType': 'blob' */

  /*  headers:{ 
      "Accept":"application/octet-stream;charset=UTF-8"
    }, */
    // headers:{"Content-Type": "application/vnd.ms-excel"},
    //headers:{"Content-Type":"application/octet-stream;charset=UTF-8"},

    /* headers:{"Content-Type": "multipart/form-data"},
    responseType: 'blob' */
    responseType: 'blob'
  }).then(res=>{
    //console.log(router.history.current);
    let fileName = router.history.current.meta.title ? router.history.current.meta.title : "导出数据";
    var blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'})
    var downloadElement = document.createElement('a');
    var href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName+'.xls'; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }).catch(error=>{
    /* console.log(router.history.current.meta.title);
    console.log(error);
    console.log(666+"error"); */
  })
};

/* 下载 excel - get */
const download = (url,params) => {
  return axios({
    url:url,
    method: 'get',
    data: params,
    withCredentials:true,
    headers:{"Content-Type": "application/vnd.ms-excel"},
    responseType: 'blob'
  }).then(res=>{

  });
}

MyHttpServer.install = function (Vue) {
	Vue.prototype.$http = axios
	Vue.prototype.$post = post;
	Vue.prototype.$get = get;
  Vue.prototype.$upload = upload;
  Vue.prototype.$download = download;
  Vue.prototype.$exportExcel = exportExcel;
}

export default MyHttpServer;
